import { UxGameController } from './ux-game-controller';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { GameId } from 'src/app/model/game/game-id';
import { UxGameServiceAction } from 'src/app/core/services/ux-game/ux-game-service-action';
import { TwentyOneMainScene } from 'src/games/phasertwentyone/game/scenes/twentyone-main-scene';
import { TwentyOneUxGameListener } from '../listeners/twentyone-ux-game-listener';
import { ActionBus } from 'game-logic';
import { TwentyOneApp } from 'src/games/phasertwentyone/game/twentyone-app';
import { TwentyOnePreloadScene } from 'src/games/phasertwentyone/game/scenes/twentyone-preload-scene';

export class TwentyOneUxGameController extends UxGameController {
  public override get gameId(): GameId {
    return GameId.TwentyOne;
  }

  private twentyOneMainScene: TwentyOneMainScene;

  constructor(
    gameListener: TwentyOneUxGameListener,
    gameServiceActionBus: ActionBus<UxGameServiceAction>,
    services: UxGameServices,
  ) {
    const useLocalDealer = false;
    const twentyOneApp = new TwentyOneApp(gameListener, services.themeService, useLocalDealer);
    const preloadScene = new TwentyOnePreloadScene(
      twentyOneApp,
      services.themeService.twentyOneAssetPath(),
    );
    preloadScene.preloadTranslations(services.translocoService);
    const mainScene = new TwentyOneMainScene(twentyOneApp);

    super(gameListener, preloadScene, mainScene, gameServiceActionBus, services);

    this.twentyOneMainScene = mainScene;
  }

  protected override resetGame(): void {
    super.resetGame();
    this.twentyOneMainScene.resetGameScene();
  }

  public override setGameVisible(isVisible: boolean): void {
    this.twentyOneMainScene.setGameVisible(isVisible);
  }
}
